// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__cOkYq","header":"styles_header__IdnWc","logo":"styles_logo__YwGZ7","content":"styles_content__BF-P4","avatar":"styles_avatar__TuNW0"};